export default __webpack_public_path__ + "182a9f8b3c9771f5235887b5c38f81a7.jpg";